import { useState } from 'react';
import { Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Commons from '../../../helpers/Commons';
import AreaUnits from '../../searchResults/rapidSearchFiltersV2/cruxFilterDropdown/components/AreaUnits';
import Colors from '../../../constants/colors';

export const renderField = ({ input, type, className, maxLength, dataTestId }) => (
    <div>
        <input
            {...input}
            type={type}
            data-testid={dataTestId}
            className={className}
            maxLength={maxLength}
            autoComplete="off"
        />
    </div>
);

const renderAreaUnit = ({
                            input,
                            setUnit,
                            field,
                            setErrors,
                            fieldValue,
                            fieldLabel,
                            validateFields,
                            setFocusedField
                        }) => {
    const handleChange = (event) => {
        setUnit(event.target.value);
        input.onChange(event);
        setFocusedField({ label: fieldLabel, field });

        if (validateFields && setErrors && field && fieldValue) {
            const mockEvent = { target: { value: fieldValue } };
            validateFields(mockEvent, field, setErrors, event.target.value);
        }
    };

    return (
        <AreaUnits
            value={input.value}
            onChange={handleChange}
            height="37px"
            borderColor={Colors.DISABLED}
            textColor={Colors.BLACK_OPAQUE}
            hideHighlight
            sx={{
                borderRadius: '0 2px 2px 0',
                lineHeight: 'unset',
                minWidth: '65px',
            }}
        />
    );
};

const LabelAndField = ({
    label,
    field,
    maxLength,
    hasUnit,
    errors,
    setFocusedField,
    setErrors,
    hasEditableUnits,
    fieldValue,
    initialValues,
                       }) => {
    const [unit, setUnit] = useState('m²');

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    };

    const validateFields = (e, field, setErrors, unit) => {
        const { value } = e.target;

        const validationRule = Commons.getValidationRule(field);
        const error = validationRule(value, unit, initialValues);
        setErrors(field, error);
    };

    const handleChange = validateFields && setErrors
        ? e => validateFields(e, field, setErrors, unit)
        : null;

    const handleFocus = setFocusedField
        ? () => setFocusedField({ label, field })
        : null;

    const parseValue = value => {
        return (value && Commons.isAllDigits(value) ? parseInt(value, 10) : value)
    };

    return (
        <div className="attribute-container" key={field}>
            <span className="attribute-label">{label}</span>
            <div data-testid="attribute-field" className={hasUnit ? 'attribute-field-with-unit' : ''}>
                <Field
                    dataTestId={field}
                    name={field}
                    id={field}
                    key={field}
                    component={renderField}
                    type="text"
                    className={`form-control attribute-field${errors[field] ? ' has-error' : ''}`}
                    onKeyPress={handleKeyPress}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    maxLength={maxLength}
                    parse={parseValue}
                    unit={unit}
                />
                {
                    hasUnit && !hasEditableUnits && (
                        <div className="attribute-unit">m<sup>2</sup></div>
                    )
                }
                {
                    hasUnit && hasEditableUnits && (
                        <Field
                            label="unit"
                            name="unit"
                            id="unit"
                            key="unit"
                            component={renderAreaUnit}
                            setUnit={setUnit}
                            field={field}
                            setErrors={setErrors}
                            fieldValue={fieldValue}
                            fieldLabel={label}
                            validateFields={validateFields}
                            setFocusedField={setFocusedField}
                        />
                    )
                }
            </div>
        </div>
    );
};

renderField.propTypes = {
    input: PropTypes.object,
    type: PropTypes.string,
    className: PropTypes.string,
    maxLength: PropTypes.number,
    dataTestId: PropTypes.string,
};

LabelAndField.propTypes = {
    label: PropTypes.string,
    field: PropTypes.any,
    maxLength: PropTypes.number,
    hasUnit: PropTypes.bool,
    errors: PropTypes.object,
    setFocusedField: PropTypes.func,
    setErrors: PropTypes.func,
    hasEditableUnits: PropTypes.bool,
    fieldValue: PropTypes.any,
};

const ConnectedLabelAndField = connect((state, ownProps) => {
    const selector = formValueSelector('updatePropertyForm');
    return {
        fieldValue: selector(state, ownProps.field),
    };
})(LabelAndField);

ConnectedLabelAndField.displayName = 'LabelAndField';

export default ConnectedLabelAndField;